/**
 * KB Editor theme definitions — mirrors the PublicDocs THEMES pattern.
 * Each key maps to Tailwind utility classes for dark vs light.
 */
export const EDITOR_THEMES = {
  dark: {
    id: 'dark',
    bg: 'bg-[#0a0a0a]',
    panelBg: 'bg-[#0c0c0c]',
    border: 'border-slate-800/80',
    borderSubtle: 'border-slate-700',
    text: 'text-white',
    textMuted: 'text-slate-400',
    textSecondary: 'text-slate-500',
    textTertiary: 'text-slate-600',
    inputBg: 'bg-slate-800',
    inputBorder: 'border-slate-700',
    inputText: 'text-white',
    editorText: 'text-slate-200',
    hover: 'hover:bg-slate-800/50',
    hoverText: 'hover:text-white',
    dropdownBg: 'bg-slate-900',
    dropdownBorder: 'border-slate-700',
    activeItem: 'bg-[#00A1B2]/15 text-white',
    divider: 'bg-slate-700/40',
    placeholder: 'placeholder:text-slate-600',
    proseClass: 'prose-invert prose-headings:font-semibold prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4 prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-3 prose-p:leading-7 prose-a:text-[#00A1B2] prose-code:text-[#00A1B2] prose-code:bg-[#00A1B2]/10 prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-pre:bg-slate-900 prose-pre:border prose-pre:border-white/10 prose-pre:rounded-xl',
    selectBg: 'bg-slate-800',
    modalOverlay: 'bg-black/60',
    cardBg: 'bg-slate-900/30',
    // Inline styles for guaranteed override
    bgStyle: {},
    panelBgStyle: {},
    inputBgStyle: {},
    dropdownBgStyle: {},
  },
  light: {
    id: 'light',
    bg: 'bg-white',
    panelBg: 'bg-gray-50',
    border: 'border-gray-200',
    borderSubtle: 'border-gray-300',
    text: 'text-gray-900',
    textMuted: 'text-gray-500',
    textSecondary: 'text-gray-400',
    textTertiary: 'text-gray-300',
    inputBg: 'bg-white',
    inputBorder: 'border-gray-300',
    inputText: 'text-gray-900',
    editorText: 'text-gray-800',
    hover: 'hover:bg-gray-100',
    hoverText: 'hover:text-gray-900',
    dropdownBg: 'bg-white',
    dropdownBorder: 'border-gray-200',
    activeItem: 'bg-[#00A1B2]/10 text-[#00A1B2]',
    divider: 'bg-gray-200',
    placeholder: 'placeholder:text-gray-400',
    proseClass: 'prose-gray prose-headings:font-semibold prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4 prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-3 prose-p:leading-7 prose-a:text-[#00A1B2] prose-code:text-[#00A1B2] prose-code:bg-[#00A1B2]/10 prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-pre:bg-gray-50 prose-pre:border prose-pre:border-gray-200 prose-pre:rounded-xl',
    selectBg: 'bg-white',
    modalOverlay: 'bg-white/60',
    cardBg: 'bg-gray-50',
    // Inline styles for guaranteed override of app-level dark CSS variables
    bgStyle: { backgroundColor: '#ffffff' },
    panelBgStyle: { backgroundColor: '#f9fafb' },
    inputBgStyle: { backgroundColor: '#ffffff' },
    dropdownBgStyle: { backgroundColor: '#ffffff' },
  },
};
